import { startCase } from "lodash";

import { classNames, Text } from "@alpacahq/ui/old";

import type { EquityWithSymbol } from "~/v2/pages/dashboard/funding/common/types";

interface EquitiesProps {
  isOpen: boolean;
  equities: EquityWithSymbol[];
}

export const Equities = ({ isOpen, equities }: EquitiesProps) => (
  <div
    className={classNames(
      "flex max-h-0 w-full flex-col gap-2 pl-4 opacity-0 transition-all",
      isOpen && "max-h-[1000px] opacity-100",
    )}
  >
    {equities.map((equity) => (
      <div
        key={equity.symbol}
        className="flex w-full items-center justify-between gap-2"
      >
        <div className="flex items-center justify-start gap-1">
          <Text className="font-medium text-gray-700 text-sm">
            {equity.symbol}
          </Text>
        </div>
        <Text className="font-medium font-mono text-gray-700 text-sm">
          {equity?.qty !== undefined ? equity.qty : "Full Amount"} (
          {startCase(equity.position.toLowerCase())})
        </Text>
      </div>
    ))}
  </div>
);
